import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { AdalService } from 'adal-angular4';
import { EMPTY } from 'rxjs';
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(public authService: AuthService, private adalService: AdalService) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Ignore Third party requests

        // const ignorelist = ['openweathermap.org', 'authentication/token'];
        // if (ignorelist.some(substr => request.url.includes(substr))) {
        //     return next.handle(request);
        // }
        // const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        // if (this.authService.isTokenExpired()) {
        //     currentUser.expires_at = null;
        //     console.log('JWT expired: ' + currentUser.token);
        //     console.log('Refreshing new JWT...');
        //     localStorage.setItem('currentUser', JSON.stringify(currentUser));
        //     this.authService.refreshToken().subscribe(data => {
        //         if (data) {
        //             currentUser.token = data.access_token;
        //             currentUser.refresh_token = data.refresh_token;
        //             currentUser.expires_at = data.expires_at;
        //             console.log('new JWT: ' + data.access_token);
        //             localStorage.setItem('currentUser', JSON.stringify(currentUser));
        //             return this.intercept(request, next);
        //         }
        //     });
        // }
        // // add authorization header with jwt token if available

        // if (currentUser && currentUser.token) {
        //     console.log('JwtInterceptor: ' + request.url);
        //     console.log('JwtInterceptor: ' + currentUser.token);
        //     request = request.clone({
        //         setHeaders: {
        //             Authorization: `Bearer ${currentUser.token}`
        //         }
        //     });
        // }
        
        // console.log('request.url: ' + request.url);
        const ignorelist = ['config.json'];
        if (ignorelist.some(substr => request.url.includes(substr))) {
            return EMPTY;
        }
        // Do not append azure token for Third party requests
        const ignoreHeaderlist = ['openweathermap.org'];
        if (ignoreHeaderlist.some(substr => request.url.includes(substr))) {
            return next.handle(request);
        }
        request = request.clone({
            setHeaders: {
                Authorization: `Bearer ${this.adalService.userInfo.token}`
            }
        });

        // console.log('TokenIntercepter called...' + this.adalService.userInfo.token);
        return next.handle(request);
    }
}
